import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		eyeIcon: {
			marginRight: theme.spacing(1)
		},
		recordsChip: {
			marginLeft: theme.spacing(1)
		},
		headerActions: {
			gap: theme.spacing(1)
		},
		selectAllLabel: {
			margin: 0
		},
		errorAlert: {
			marginBottom: theme.spacing(2)
		},
		errorList: {
			margin: 0,
			paddingLeft: theme.spacing(2)
		},
		warningsCard: {
			marginBottom: theme.spacing(2),
			border: `1px solid ${theme.palette.warning.main}`
		},
		warningsHeader: {
			backgroundColor: theme.palette.warning.light,
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(1)
		},
		warningsIcon: {
			color: 'white'
		},
		warningsTitle: {
			color: 'white',
			fontWeight: 600
		},
		warningsActionButton: {
			color: 'white'
		},
		warningsContent: {
			paddingTop: 0
		},
		warningsList: {
			margin: 0,
			paddingLeft: theme.spacing(2)
		},
		warningItem: {
			marginBottom: theme.spacing(0.5)
		},
		loadingText: {
			marginLeft: theme.spacing(2)
		},
		emptyStateIcon: {
			fontSize: 48,
			color: theme.palette.grey[400],
			marginBottom: 16
		},
		checkboxCards: {
			paddingTop: theme.spacing(2)
		},
		checkboxJson: {
			alignSelf: 'flex-start',
			paddingTop: 0
		},
		jsonPaper: {
			padding: theme.spacing(2)
		},
		jsonPre: {
			backgroundColor: theme.palette.grey[100],
			padding: theme.spacing(1),
			borderRadius: 4,
			fontSize: '0.75rem',
			fontFamily: 'monospace',
			overflow: 'auto',
			maxHeight: 400,
			margin: 0
		},
		selectionSummary: {
			marginTop: theme.spacing(2),
			padding: theme.spacing(2),
			borderRadius: theme.spacing(1)
		}
	} satisfies Record<string, CSSObject>;
};